import { StyleSheet, View } from 'react-native';
import { Button } from '../../crop-circle/Button';

export type QuickConfirmExecutionComponentProps = {
  options: string[];
  confirmedValue: string;
  onChange: (confirmedValue: string) => void;
};

export const QuickConfirmExecutionComponent = (
  props: QuickConfirmExecutionComponentProps
) => {
  const lastValue = props.options[props.options.length - 1];

  return (
    <View style={styles.buttonsContainer}>
      {props.options.length > 1
        ? props.options.map((confirmedValue) => {
            return (
              <Button
                key={confirmedValue}
                onPress={() => props.onChange(confirmedValue)}
                size="large"
                variant="rectangular"
                state={lastValue === confirmedValue ? 'active' : 'default'}
              >
                {confirmedValue}
              </Button>
            );
          })
        : null}
    </View>
  );
};

const styles = StyleSheet.create({
  buttonsContainer: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: 16,
  },
});
